import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Button, FormControl, Box, Paper, OutlinedInput } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import {
  clearCloneProject,
  cloneProject,
  getPreProProjects,
} from "../../../redux/pre_processor/actions";
import "./cloneModal.scss";
import CustomizedSnackbars from "../../Snackbars/CustomizedSnackbars";

export default function CloneModal({ open, onCloseClone }) {
  const [projectName, setProjectName] = useState(
    localStorage.projectName + "_clone"
  );
  const dispatch = useDispatch();
  // const apiStatus = useSelector((state) => state?.prePro?.apiStatus);
  const cloneApiStatus = useSelector((state) => state?.prePro?.cloneApiStatus);
  const [notification, setNotification] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");

  // useEffect(() => {
  //   if (apiStatus && apiStatus !== undefined) {
  //     if (apiStatus.loading === true) {
  //     }
  //     if (apiStatus.loading === false) {
  //       if (apiStatus.next === true || apiStatus.message !== null) {
  //         setTimeout(() => {
  //           onCloseClone(false);
  //           dispatch(
  //             getPreProProjects({
  //               type: "",
  //               formattedStartDate: "",
  //               formattedEndDate: "",
  //               status: "",
  //             })
  //           );
  //         }, 2000);
  //       }
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [apiStatus]);

  useEffect(() => {
    if (cloneApiStatus?.apiError) {
      setMessage(cloneApiStatus?.message);
      setSeverity("error");
      setNotification(true);
      dispatch(clearCloneProject());
    }
    if (
      cloneApiStatus?.next === true &&
      cloneApiStatus?.message !==null &&
      cloneApiStatus?.apiSuccess === true
    ) {
      setNotification(true);
      setMessage(cloneApiStatus?.message);
      setSeverity("success");
      dispatch(clearCloneProject());
      setTimeout(() => {
        onCloseClone(false);
        dispatch(
          getPreProProjects({
            type: "",
            formattedStartDate: "",
            formattedEndDate: "",
            status: "",
          })
        );
      }, 2000);
    }
  }, [cloneApiStatus]);

  const handleProjectName = (name) => {
    setProjectName(name);
  };
  const submit = () => {
    // onCloseClone(false);
    dispatch(cloneProject(projectName));
  };

  return (
    <div>
      <Modal open={open}>
        <Box component={Paper} className="modal-box">
          <CloseIcon
            className="cloneModal-close"
            onClick={() => onCloseClone()}
          />
          <Typography id="modal-modal-title" variant="h8" component="h4">
            Clone Project
          </Typography>

          <FormControl fullWidth>
            <div className="clone">
              <OutlinedInput
                size="small"
                fullWidth
                placeholder="Project Name"
                value={projectName}
                onChange={(e) => handleProjectName(e.target.value)}
                className="projectName-outline"
              />
              <Button className="button-clone" onClick={submit}>
                Clone
              </Button>
            </div>
          </FormControl>
        </Box>
      </Modal>

      {notification && (
        <CustomizedSnackbars
          severity={severity}
          state={notification}
          text={message}
          handleClose={() => setNotification(false)}
        />
      )}
    </div>
  );
}
